export default __webpack_public_path__ + "static/media/PersonalPlanMobile1024.63c43d18.png";